import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TActivityDeviceLog, TActivityList } from "../../../context/ActivityProvider";
import { PaginationTable } from "../../table/PaginationTable";
import { Table } from "../../table/Table";
import NotActivityFound from "../NotActivityFound";
import { BodyTableDeviceLogs } from "./BodyTableDeviceLogs";

interface TableDeviceLogsProps {
  offset: number;
  setOffset: (value: number) => void;
  limit: number;
  setLimit: (value: number) => void;
  activityList: TActivityList;
}

export const TableDeviceLogs = ({
  activityList,
  limit,
  offset,
  setLimit,
  setOffset,
}: TableDeviceLogsProps): JSX.Element => {
  const { t } = useTranslation();

  const i18n = (key: string) => t(`activity-directory.table.header.${key}`);

  const isPaginated = useMemo(
    () => (activityList?.count ?? 0) > 10,
    [activityList?.count]
  );

  const columns = useMemo(
    () => [
      { id: "actor", label: i18n("actor") },
      { id: "created_at", label: i18n("created_at") },
      { id: "device", label: i18n("device") },
      { id: "event_type", label: i18n("event_type") },
    ],
    [t]
  );

  const hasNoResults = (activityList?.count ?? 0) === 0;

  return (
    <div className="relative">
      {isPaginated && (
        <PaginationTable
          limit={limit}
          setLimit={setLimit}
          total={activityList?.count ?? 0}
          offset={offset}
          setOffset={setOffset}
        />
      )}

      <Table columns={columns}>
        {hasNoResults ? (
          <tr>
            <td colSpan={columns.length} className="text-center py-4">
              <NotActivityFound />
            </td>
          </tr>
        ) : (
          <BodyTableDeviceLogs
            rows={activityList.results as TActivityDeviceLog[]}
          />
        )}
      </Table>
    </div>
  );
};
